const IconHome = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.75 3.70463L16.5 10.4546V15.1875C16.5 15.6351 16.3222 16.0643 16.0057 16.3807C15.6893 16.6972 15.2601 16.875 14.8125 16.875H4.6875C4.23995 16.875 3.81072 16.6972 3.49426 16.3807C3.17779 16.0643 3 15.6351 3 15.1875V10.4546L9.75 3.70463ZM15.375 2.8125V6.75L13.125 4.5V2.8125C13.125 2.66332 13.1843 2.52024 13.2898 2.41475C13.3952 2.30926 13.5383 2.25 13.6875 2.25H14.8125C14.9617 2.25 15.1048 2.30926 15.2102 2.41475C15.3157 2.52024 15.375 2.66332 15.375 2.8125Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.9546 1.68754C9.16557 1.47663 9.45167 1.35815 9.74998 1.35815C10.0483 1.35815 10.3344 1.47663 10.5454 1.68754L18.0232 9.16429C18.1289 9.26991 18.1882 9.41317 18.1882 9.56254C18.1882 9.71191 18.1289 9.85517 18.0232 9.96079C17.9176 10.0664 17.7744 10.1257 17.625 10.1257C17.4756 10.1257 17.3323 10.0664 17.2267 9.96079L9.74998 2.48291L2.27323 9.96079C2.16761 10.0664 2.02435 10.1257 1.87498 10.1257C1.72561 10.1257 1.58235 10.0664 1.47673 9.96079C1.37111 9.85517 1.31177 9.71191 1.31177 9.56254C1.31177 9.41317 1.37111 9.26991 1.47673 9.16429L8.9546 1.68754Z"
      fill="currentColor"
    />
  </svg>
);
export default IconHome;
